<template>
  <div class="student-dashboard" data-theme="default">
    <page-loader-container />
    <modals-container />
    <toast-container />

    <pwa-installer />

    <app-standalone v-if="standalone" />
    <app-plugin v-else />
  </div>
</template>

<style lang="scss">
@import 'assets/stylesheets/application';
@import 'assets/stylesheets/common';
</style>

<script>
import AppConfig from 'utils/app-config';
import AppPlugin from 'app-plugin';
import AppStandalone from 'app-standalone';
import PwaInstaller from 'pwa-installer';

export default {
  components: {
    AppPlugin,
    AppStandalone,
    'pwa-installer': PwaInstaller,
  },
  computed: {
    standalone() {
      return AppConfig.get('standalone');
    },
  },
};
</script>
